
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lC8Ua", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("7RTOK")).AgilePageLayout; });

var $7RTOK = parcelRequire("7RTOK");

});
parcelRegister("7RTOK", function(module, exports) {
$parcel$export(module.exports, "AgilePageLayout", function () { return $530783ba2f6753cb$export$ec9acf8ba54ff52d; });
/* agile-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $76zkt = parcelRequire("76zkt");

var $1Enm0 = parcelRequire("1Enm0");
const $530783ba2f6753cb$var$agilePageLayoutCss = null;
// NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
const $530783ba2f6753cb$var$articleStyles = null;
const $530783ba2f6753cb$export$ec9acf8ba54ff52d = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0eaigu _2z05f5ih _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _1q51zwfg _85i5ckbl _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $76zkt.AgileHubSideNav), {
                nodes: (0, $1Enm0.useAgileHubPageTreeData)()
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("article", {
                className: (0, $2jatx.default)([
                    "_1461kb7n _f0zu1mrw _dz5jegat _125x18q9 _q7gq1cby _zcqx14u8 _8v2fqlpn _1yziqlpn _1601qlpn _l5k1bfng _r8ntbfng _1a7kbfng _cg411tj6 _qliy1tj6 _1rhq1tj6 _11eb1k8s _17z415sy _qc0pahaf _ggmh1k92 _1axi11ph _1o6v7vkz _ugctnl7k _1edj1k8s _8kc91k92 _1euycjiy _k6x07vkz _8lldnl7k",
                    "main-content"
                ]),
                style: {
                    "--_nmjf06": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.navy")),
                    "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                    "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
                },
                children: children
            })
        ]
    });
};
var $530783ba2f6753cb$export$2e2bcd8739ae039 = $530783ba2f6753cb$export$ec9acf8ba54ff52d;

});


parcelRegister("k0vdv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("GwtXK")).ArticleShare; });

var $GwtXK = parcelRequire("GwtXK");

});
parcelRegister("GwtXK", function(module, exports) {
$parcel$export(module.exports, "ArticleShare", function () { return $c0b594d5bd8658ca$export$8316e2489e314828; });
/* article-share.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a7T4F = parcelRequire("a7T4F");
const $c0b594d5bd8658ca$var$ArticleShareContainerStyle = null;
const $c0b594d5bd8658ca$var$ColumnStyles = null;
const $c0b594d5bd8658ca$export$8316e2489e314828 = ({ description: description, link: link, title: title, source: source })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _bfhku67f _1tke1n2x _1n261g80 _s7n41q9y"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1bsb1osq _2lx21bp4 _1aax1e5h _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
            ]),
            children: description && link && title && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a7T4F.SocialShareMenu), {
                description: description,
                link: link,
                title: title,
                source: source
            })
        })
    });
};

});
parcelRegister("a7T4F", function(module, exports) {
$parcel$export(module.exports, "SocialShareMenu", function () { return $e02d9a9fc286ca33$export$22d14db7e0bd3bb5; });
/* social-share-menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");
const $e02d9a9fc286ca33$var$socialShareButtonStyle = {
    base: "_1e0c1o8l _1bsb1u1b _4t3i1u1b _1reo15vq _18m915vq",
    facebook: "_11q7153z _1lrw1osq",
    twitter: "_1itk1dl8 _12vemgnk _1lrw1osq _uokl1h6o",
    linkedin: "_1itk7ct8 _12vemgnk _1lrw1osq"
};
const $e02d9a9fc286ca33$var$SocialShareButtonActions = {
    facebook: {
        action: "https://www.facebook.com/dialog/feed",
        params: (props)=>({
                app_id: "743864389089816",
                caption: props.title,
                link: props.link,
                description: props.description,
                picture: "",
                name: props.title
            })
    },
    twitter: {
        action: "https://twitter.com/share",
        params: (props)=>({
                text: props.description,
                url: props.link,
                via: props.source
            })
    },
    linkedin: {
        action: "https://www.linkedin.com/shareArticle",
        params: (props)=>({
                mini: "true",
                url: props.link,
                title: props.title,
                summary: props.description,
                source: props.source
            })
    }
};
const $e02d9a9fc286ca33$export$49e0960a058fa5ad = ({ title: title, variant: variant, action: action })=>{
    const href = (0, $1oC0p.useMemo)(()=>{
        const actionDescriptor = $e02d9a9fc286ca33$var$SocialShareButtonActions[variant];
        const url = new URL(actionDescriptor.action);
        const params = new URLSearchParams(actionDescriptor.params(action));
        for (const [key, value] of params.entries())url.searchParams.set(key, value);
        return url.href;
    }, [
        variant,
        action
    ]);
    const clickHandler = (0, $1oC0p.useCallback)((e)=>{
        if (typeof window !== "undefined") {
            window.open(href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600");
            e.preventDefault();
        }
    }, [
        href
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "Share to Social Media",
        href: href,
        title: title,
        onClick: clickHandler,
        className: (0, $2jatx.default)([
            $e02d9a9fc286ca33$var$socialShareButtonStyle.base,
            $e02d9a9fc286ca33$var$socialShareButtonStyle[variant]
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            style: {
                pointerEvents: "none",
                visibility: "hidden"
            },
            children: title
        })
    });
};
const $e02d9a9fc286ca33$var$socialShareMenuItemStyle = null;
const $e02d9a9fc286ca33$var$socialShareMenuStyle = null;
const $e02d9a9fc286ca33$var$shareTextStyle = null;
const $e02d9a9fc286ca33$export$22d14db7e0bd3bb5 = ({ description: description, link: link, title: title, source: source })=>{
    const intl = (0, $8e22h.default)();
    const action = (0, $1oC0p.useMemo)(()=>({
            title: title,
            description: description,
            link: link,
            source: source !== null && source !== void 0 ? source : "Atlassian"
        }), [
        description,
        link,
        title,
        source
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_syaz1bqd _1e0c1txw _2lx21bp4 _y3gn1e5h",
                    "eyebrow-md"
                ]),
                children: intl.formatMessage({
                    id: "Agile.article.share",
                    defaultMessage: "Share this article"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("ul", {
                className: (0, $2jatx.default)([
                    "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        className: (0, $2jatx.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($e02d9a9fc286ca33$export$49e0960a058fa5ad, {
                            variant: "facebook",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.facebook",
                                defaultMessage: "Share on Facebook"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        className: (0, $2jatx.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($e02d9a9fc286ca33$export$49e0960a058fa5ad, {
                            variant: "twitter",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.twitter",
                                defaultMessage: "Share on Twitter"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                        className: (0, $2jatx.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($e02d9a9fc286ca33$export$49e0960a058fa5ad, {
                            variant: "linkedin",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.linkedin",
                                defaultMessage: "Share on LinkedIn"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("l2g60", function(module, exports) {
$parcel$export(module.exports, "AgileBreadcrumbs", function () { return $735d3e745f877242$export$2ce562bcf8da2de8; });

var $7VQPk = parcelRequire("7VQPk");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $1Enm0 = parcelRequire("1Enm0");

var $eGE8t = parcelRequire("eGE8t");

var $1ka2O = parcelRequire("1ka2O");
const $735d3e745f877242$export$71ac4f9beafb009b = (paths)=>{
    const agileTree = (0, $1Enm0.useAgileHubPageTreeData)();
    const names = paths.map((path)=>{
        if (path === "/agile") return {
            name: "Agile",
            path: "/agile"
        };
        const node = agileTree.find((obj)=>path.includes(obj.urlSlug));
        if (node) {
            if (path === node.urlSlug) return {
                name: node.name,
                path: node.urlSlug
            };
            else {
                const childNode = node.children && node.children.find((obj)=>path === obj.urlSlug);
                if (childNode) return {
                    name: childNode.name,
                    path: childNode.urlSlug
                };
            }
        }
        return {
            name: "",
            path: ""
        };
    });
    return names;
};
const $735d3e745f877242$export$2ce562bcf8da2de8 = ()=>{
    const location = (0, $1ka2O.useLocation)();
    const { pathname: pathname } = location;
    const segmentPaths = (0, $eGE8t.getProgressivePathSegments)(pathname);
    const segmentObjs = $735d3e745f877242$export$71ac4f9beafb009b(segmentPaths);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "12",
        alignItems: "top",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Breadcrumbs), {
            links: segmentObjs
        })
    });
};

});
parcelRegister("eGE8t", function(module, exports) {
$parcel$export(module.exports, "getProgressivePathSegments", function () { return $2a86afadc81737ae$export$d491212abeef3206; });

var $80kL5 = parcelRequire("80kL5");
const $2a86afadc81737ae$export$d491212abeef3206 = (path)=>{
    let proPath = "/";
    if (!path || !path.startsWith("/")) return [];
    return path.split("/").filter(Boolean) // remove empty array elements
    .filter((p)=>!(0, $80kL5.isValidLocale)(p)).map((value)=>{
        proPath += `${value}/`;
        return proPath.replace(/\/$/, "");
    });
};

});


parcelRegister("fAGfJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("fbqbV")).AgileHeading; });

var $fbqbV = parcelRequire("fbqbV");

});
parcelRegister("fbqbV", function(module, exports) {
$parcel$export(module.exports, "AgileHeading", function () { return $f89c2a2dbe515de5$export$9f1161956c98afd6; });
/* agile-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $HMZ3r = parcelRequire("HMZ3r");

var $5HK05 = parcelRequire("5HK05");
const $f89c2a2dbe515de5$var$headerStyles = null;
const $f89c2a2dbe515de5$var$eyebrowStyles = null;
const $f89c2a2dbe515de5$var$h1Styles = null;
const $f89c2a2dbe515de5$var$pStyles = null;
// TODO: Switch to shared Article Grid component
// or at least exported widths/paddings, once in place
const $f89c2a2dbe515de5$var$contentBlockStyles = null;
const $f89c2a2dbe515de5$var$authorStyles = null;
const $f89c2a2dbe515de5$var$headshotStyles = null;
const $f89c2a2dbe515de5$export$9f1161956c98afd6 = ({ title: title, eyebrow: eyebrow, description: description, imageUrl: imageUrl, author: author })=>{
    var _author_authorPicture;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("header", {
        style: imageUrl ? {
            backgroundImage: `url(${imageUrl})`
        } : undefined,
        className: (0, $2jatx.default)([
            "_1lrw1dfr _1rjc1jly _1e0c11p5 _4cvr1h6o _6a6z1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _p12fzqdx _ca0q1j6v _u5f3viql _n3tdidpf _19bvviql _bfhku67f _su071wqb"
            ]),
            children: [
                eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_syazvwuj _1wyboqnp _1dyzt94y _vwz4cs5v _1p1dangw",
                        "eyebrow-sm"
                    ]),
                    children: eyebrow
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                    className: (0, $2jatx.default)([
                        "_k48pbfng _1wyb1lne _1pfh7vkz _6rth7vkz _1dyzidpf _vwz410nf _syaz1bqd _d8hs1tcg"
                    ]),
                    children: title
                }),
                description && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1wyb1k92 _vwz419ii _6rth7vkz _syaz1bqd _1tnt1tcg",
                        "body-lg"
                    ]),
                    children: description
                }),
                author && /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                    className: (0, $2jatx.default)([
                        "_1wyboxwj _1e0c1txw _zulp1j6v _4cvr1h6o _1p1dangw",
                        "body-sm"
                    ]),
                    children: [
                        ((_author_authorPicture = author.authorPicture) === null || _author_authorPicture === void 0 ? void 0 : _author_authorPicture.url) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $HMZ3r.default), {
                            src: author.authorPicture.url,
                            baseWidth: 36,
                            width: 36,
                            height: 36,
                            alt: "",
                            className: (0, $2jatx.default)([
                                "_2rko1ssb _1bsbahaf _4t3iahaf _5ral1dfr"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "agile.heading.author.byline",
                            defaultMessage: "by {authorName}",
                            values: {
                                authorName: (0, $5HK05.expectContent)(author.name, "Author name not found")
                            }
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("fwlSR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("jn6Rg")).AgileIntroduction; });

var $jn6Rg = parcelRequire("jn6Rg");

});
parcelRegister("jn6Rg", function(module, exports) {
$parcel$export(module.exports, "AgileIntroduction", function () { return $935e39e6d0895af9$export$e27c7ba731ddc3de; });
/* agile-introduction.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $gtz2R = parcelRequire("gtz2R");

var $acgWW = parcelRequire("acgWW");

var $hS8MU = parcelRequire("hS8MU");

var $B5GRx = parcelRequire("B5GRx");
const $935e39e6d0895af9$var$headingStyle = null;
const $935e39e6d0895af9$var$contentWrapperCss = null;
const $935e39e6d0895af9$export$e27c7ba731ddc3de = ({ heading: heading, description: description, image: image, embedLink: embedLink, body: body })=>{
    var _image_description;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            heading && /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_1pfhidpf"
                ]),
                children: heading
            }),
            description && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $B5GRx.RichTextComponent), {
                    text: description,
                    name: null
                })
            }),
            embedLink && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gtz2R.AgileVideo), {
                    embedLink: embedLink,
                    title: (_image_description = image === null || image === void 0 ? void 0 : image.description) !== null && _image_description !== void 0 ? _image_description : "",
                    thumbnail: image !== null && image !== void 0 ? image : null
                })
            }),
            image && !embedLink && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hS8MU.BodyAssetComponent), {
                    asset: image
                })
            }),
            body === null || body === void 0 ? void 0 : body.map((component, idx)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_6rthgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $acgWW.RichContent), (0, $6Ppys._)({}, component))
                }, idx))
        ]
    });
};

});



//# sourceMappingURL=agile-article.c0cb5887.js.map
